import { useParams } from "react-router-dom"
import { Button, Col, Row, Space } from "antd"
import { baseAxiosComplete } from "../../../tool/axios"

interface data {
    room_number: string,
    check_in_day_range: string,
    room_type_name: string
}

interface checkInRecordData {
    room_number: string,
    check_in_day_range: string,
    room_type_name: string
}

interface Prop {
    status: any,
    data: checkInRecordData[]
    onFetched?: (d?: data[]) => void
}

export default function (prop: Prop) {

    const params: any = useParams()

    return <div className="modules">
        {/* 管家中心 -> 入住管理 -> 客户详情 -> 入住信息 */}
        <div className="top clear">
            <h3 className="fl"><span className="fl">入住信息</span>
                {
                    prop.status != '客户退单' ? (
                        <Button
                            onClick={() => {
                                baseAxiosComplete.post('/keeper/check_in/detail/reset_room', {
                                    check_in_id: params.id
                                }).then(res => {
                                    if (res.status == 0) {
                                        if (prop.onFetched) { prop.onFetched() }
                                    }
                                })
                            }}
                            size="small"
                            type="dashed"
                            style={{ marginLeft: 10, fontSize: 12 }}>
                            清空入住信息
                        </Button>
                    ) : null
                }
            </h3>
        </div>

        <div className="content">
            {prop.data.map((el: data) => <Row style={{ width: '100%', marginTop: 15, marginLeft: 20}}>
                <Col span={6}>
                    <Space wrap>
                        <p>房间号：</p>
                        <p className="right-text">{el.room_number}</p>
                    </Space>
                </Col>

                <Col span={7}>
                    <Space wrap>
                        <p>入住时间段：</p>
                        <p className="right-text">{el.check_in_day_range}</p>
                    </Space>
                </Col>

                <Col span={6}>
                    <Space wrap>
                        <p>房型：</p>
                        <p className="right-text">{el.room_type_name}</p>
                    </Space>
                </Col>
            </Row>)}
        </div>
    </div>
}